import { accessRole } from "../../../../helpers/access_role"
import classnames from 'classnames'
import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"


import moment from "moment"
import IndexBloc from "./Blocs/IndexBlock"

import CustomSelect from "../../GlobalComponents/CustomSelect"

import TableActiveComponent from './Components/TableActiveComponent'
import TableSecondComponent from "./Components/TableSecondComponent"

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}
  
const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

const IndexView = (props) => {
    
    
    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const secondRef = useRef();
    
    // Select
    const [yearOptions, setYearOptions] = useState(createYearOption(new Date().getFullYear() - 30));
    const [monthOptions, setMonthOptions] = useState(createMonthOptions());
    
    // Filter
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')
    const [year, setYear] = useState(new Date().getFullYear())
    const [month, setMonth] = useState(moment().format('M'))

    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    
    let additionalFilter = {
        nip: nip,
        name: name,
        year: year,
        month: month,
        start_date: startDate,
        end_date: endDate
    };
    
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadSecondRef = () => secondRef.current.setTokenAPI()
    const exportketidakhadiranActiveRef = () => activeRef.current.exportKetidakhadiranExcel()
    
    function handleButtonSearch() {
        reloadActiveRef()
        reloadSecondRef()
    }
    
    function handleButtonReset() {
        setNip('');
        setName('');
        reloadActiveRef()
    }
    function handleButtonKetidakhadiranExport(){
        exportketidakhadiranActiveRef();
    }
    
    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>List Data Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Seluruh Pegawai
                                </CardSubtitle>
                                <hr />

                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    NIP
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="nip"
                                            value={nip}
                                            onChange={event => setNip(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row> */}

                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    Nama
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="name"
                                            value={name}
                                            onChange={event => setName(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row> */}

                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="no_skx"
                                        className="col-md-2 col-form-label"
                                    >
                                    Bulan <span className="text-danger">*</span>
                                    </label>
                                    <Col md="2">
                                        <CustomSelect 
                                            name="period_month"
                                            errorMessage="Pilih Bulan"
                                            options={monthOptions} 
                                            placeholder="Pilih Bulan"
                                            defaultValue={month}
                                            onChange={(v) => setMonth(v.value)}
                                            isAvForm={false}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="no_skx"
                                        className="col-md-2 col-form-label"
                                    >
                                    Tahun <span className="text-danger">*</span>
                                    </label>
                                    <Col md="2">
                                        <CustomSelect 
                                            name="period_year"
                                            errorMessage="Pilih Tahun"
                                            options={yearOptions} 
                                            placeholder="Pilih Tahun"
                                            defaultValue={year}
                                            onChange={(v) => setYear(v.value)}
                                            isAvForm={false}
                                        />
                                    </Col>
                                </Row> */}

                                

                                <Row className="mb-1">
                                    <label className="col-md-2">
                                        Periode Mulai
                                    </label>
                                    <Col md="3">
                                        <Input
                                            name="start_period"
                                            placeholder="Periode Mulai..."
                                            type="date"
                                            errorMessage="Masukkan Periode Mulai"
                                            className="form-control"
                                            onChange={event => setStartDate(event.target.value)}
                                            id="start_period"
                                            value={startDate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-2">
                                        Periode Akhir
                                    </label>
                                    <Col md="3">
                                        <Input
                                            name="end_period"
                                            placeholder="Periode Akhir..."
                                            type="date"
                                            errorMessage="Masukkan Periode Akhir"
                                            className="form-control"
                                            onChange={event => setEndDate(event.target.value)}
                                            id="end_period"
                                            value={endDate}
                                        />
                                    </Col>
                                </Row>
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button>
                                        {' '}
                                        {/* <Button 
                                          color="success" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonKetidakhadiranExport()
                                          }}
                                        >
                                            Export Rekap Ketidakhadiran
                                        </Button> */}
                                    </Col>
                                </Row>

                                <hr />

                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                            <span className="d-none d-sm-block">Akumulasi</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "2",
                                                })}
                                            onClick={() => {
                                                toggle("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Rekap Absensi</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId="1">
                                        <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TableSecondComponent ref={secondRef} />
                                    </TabPane>
                                </TabContent>
                                
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView